import LabelRepair from '@features/LabelRepair/ui/LabelRepair';

export default function LabelRepairPage() {
  return <LabelRepair />;
}
